webpackJsonp([71927732402021],{

/***/ 707:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 386:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(707);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var photos = [];
	
	for (var i = 0; i < 10; i++) {
	  photos.push(i);
	}
	
	var HistoryDemo = function HistoryDemo(_ref) {
	  var configuration = _ref.configuration,
	      scPromise = _ref.scPromise;
	  return _react2.default.createElement(
	    'div',
	    { className: 'history-demo' },
	    configuration && configuration[0] === 'gallery' && _react2.default.createElement(Gallery, { scPromise: scPromise }),
	    configuration && configuration[0] === 'carousel' && _react2.default.createElement(Carousel, { scPromise: scPromise }),
	    configuration && configuration[0] === 'modal-open' && _react2.default.createElement(Modal, { scPromise: scPromise })
	  );
	};
	
	var OpenModalButton = function OpenModalButton(_ref2) {
	  var scPromise = _ref2.scPromise;
	  return _react2.default.createElement(
	    'button',
	    { onClick: function onClick() {
	        return scPromise.then(function (sc) {
	          return sc.gen('open-modal');
	        });
	      } },
	    ' Open modal '
	  );
	};
	
	var Gallery = function Gallery(_ref3) {
	  var scPromise = _ref3.scPromise;
	  return _react2.default.createElement(
	    'div',
	    { className: 'gallery' },
	    _react2.default.createElement(
	      'button',
	      { onClick: function onClick() {
	          return scPromise.then(function (sc) {
	            return sc.gen('go-to-carousel');
	          });
	        } },
	      ' Go to carousel '
	    ),
	    _react2.default.createElement(OpenModalButton, { scPromise: scPromise }),
	    _react2.default.createElement(
	      'div',
	      null,
	      ' Gallery '
	    ),
	    photos.map(function (i) {
	      return _react2.default.createElement(
	        'div',
	        { key: i, className: 'placeholder' },
	        i
	      );
	    })
	  );
	};
	
	var Carousel = function (_React$Component) {
	  _inherits(Carousel, _React$Component);
	
	  function Carousel(props) {
	    _classCallCheck(this, Carousel);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.clickLeft = _this.clickLeft.bind(_this);
	    _this.clickRight = _this.clickRight.bind(_this);
	    _this.state = { index: 5 };
	    return _this;
	  }
	
	  Carousel.prototype.clickLeft = function clickLeft() {
	    var index = this.state.index - 1;
	    if (index > -1) {
	      this.setState({ index: index });
	    }
	  };
	
	  Carousel.prototype.clickRight = function clickRight() {
	    var index = this.state.index + 1;
	    if (index < photos.length) {
	      this.setState({ index: index });
	    }
	  };
	
	  Carousel.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'carousel' },
	      _react2.default.createElement(
	        'button',
	        { onClick: function onClick() {
	            return _this2.props.scPromise.then(function (sc) {
	              return sc.gen('go-to-gallery');
	            });
	          } },
	        ' Go to gallery '
	      ),
	      _react2.default.createElement(OpenModalButton, { scPromise: this.props.scPromise }),
	      _react2.default.createElement(
	        'div',
	        null,
	        ' Carousel '
	      ),
	      _react2.default.createElement(
	        'button',
	        { onClick: this.clickLeft, disabled: i === 0 },
	        '\u2190'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'placeholder' },
	        this.state.index
	      ),
	      _react2.default.createElement(
	        'button',
	        { onClick: this.clickRight, disabled: i === photos.length - 1 },
	        '\u2192'
	      )
	    );
	  };
	
	  return Carousel;
	}(_react2.default.Component);
	
	var Modal = function Modal(_ref4) {
	  var scPromise = _ref4.scPromise;
	  return _react2.default.createElement(
	    'div',
	    { className: 'demo-modal' },
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'span',
	        { className: 'close-icon', onClick: function onClick() {
	            return scPromise.then(function (sc) {
	              return sc.gen('close-modal');
	            });
	          } },
	        ' \xD7 '
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      ' This is a modal dialog '
	    )
	  );
	};
	
	exports.default = HistoryDemo;
	module.exports = exports['default'];

/***/ }),

/***/ 884:
/***/ (function(module, exports) {

	module.exports = "import React from 'react'\nimport './history-demo.css';\n\nconst photos = []\n\nfor(var i = 0; i < 10; i++){\n  photos.push(i);\n}\n\nconst HistoryDemo = ({configuration, scPromise}) => (\n  <div className=\"history-demo\">\n    {\n      (configuration && configuration[0] === 'gallery') && <Gallery scPromise={scPromise} />\n    }\n    {\n      (configuration && configuration[0] === 'carousel') && <Carousel scPromise={scPromise} />\n    }\n    {\n      (configuration && configuration[0] === 'modal-open') && <Modal scPromise={scPromise} />\n    }\n  </div>\n)\n\nconst OpenModalButton = ({scPromise}) => (\n  <button onClick={() => scPromise.then( (sc) => sc.gen('open-modal') )}> Open modal </button>\n)\n\nconst Gallery = ({scPromise}) => (\n  <div className=\"gallery\">\n    <button onClick={ () => scPromise.then( (sc) => sc.gen('go-to-carousel') )}> Go to carousel </button>\n    <OpenModalButton scPromise={scPromise} />\n    <div> Gallery </div>\n    {\n      photos.map( i => (\n        <div key={i} className=\"placeholder\">\n          {i}\n        </div>\n      ))\n    }\n  </div>\n)\n\nclass Carousel extends React.Component {\n  constructor(props){\n    super(props)\n    this.clickLeft = this.clickLeft.bind(this)\n    this.clickRight = this.clickRight.bind(this)\n    this.state = {index : 5}\n  }\n\n  clickLeft(){\n    const index = this.state.index-1\n    if(index > -1){\n      this.setState({index})\n    }\n  }\n\n  clickRight(){\n    const index = this.state.index+1\n    if(index < photos.length){\n      this.setState({index})\n    }\n  }\n\n  render(){\n    return <div className=\"carousel\">\n      <button onClick={ () => this.props.scPromise.then( (sc) => sc.gen('go-to-gallery') )}> Go to gallery </button>\n      <OpenModalButton scPromise={this.props.scPromise} />\n      <div> Carousel </div>\n      <button onClick={this.clickLeft} disabled={i === 0}>&larr;</button>\n      <div className=\"placeholder\">\n        {this.state.index}\n      </div>\n      <button onClick={this.clickRight} disabled={i === (photos.length - 1)}>&rarr;</button>\n    </div>\n  }\n}\n\nconst Modal = ({scPromise}) => (\n  <div className=\"demo-modal\">\n    <div>\n      <span className=\"close-icon\" onClick={() => scPromise.then( (sc) => sc.gen('close-modal') )}> &times; </span>\n    </div>\n    <div> This is a modal dialog </div>\n  </div>\n)\n\nexport default HistoryDemo; \n"

/***/ }),

/***/ 885:
/***/ (function(module, exports) {

	module.exports = "<scxml initial=\"modal-closed\">\n  <state id=\"modal-closed\" initial=\"gallery\">\n    <state id=\"gallery\">\n      <transition target=\"carousel\" event=\"go-to-carousel\"/>\n    </state>\n    <state id=\"carousel\">\n      <transition target=\"gallery\" event=\"go-to-gallery\"/>\n    </state>\n    <history id=\"reentry\"/>\n    <transition event=\"open-modal\" target=\"modal-open\"/>\n  </state>\n  <state id=\"modal-open\">\n    <transition event=\"close-modal\" target=\"reentry\"/>\n  </state>\n</scxml>\n"

/***/ }),

/***/ 387:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.HistoryExample = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _schviz = __webpack_require__(13);
	
	var _schviz2 = _interopRequireDefault(_schviz);
	
	var _history = __webpack_require__(885);
	
	var _history2 = _interopRequireDefault(_history);
	
	var _historyDemo = __webpack_require__(386);
	
	var _historyDemo2 = _interopRequireDefault(_historyDemo);
	
	var _historyDemo3 = __webpack_require__(884);
	
	var _historyDemo4 = _interopRequireDefault(_historyDemo3);
	
	var _components = __webpack_require__(68);
	
	var _common = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HistoryExample = exports.HistoryExample = function (_SCComponent) {
	  _inherits(HistoryExample, _SCComponent);
	
	  function HistoryExample(props) {
	    _classCallCheck(this, HistoryExample);
	
	    return _possibleConstructorReturn(this, _SCComponent.call(this, props, _history2.default));
	  }
	
	  HistoryExample.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'table',
	        { style: { width: '100%', height: '400px' } },
	        _react2.default.createElement(
	          'tbody',
	          null,
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(_common.Cell, {
	              contentHeight: '400px',
	              showSourceCode: this.state.showSourceCode,
	              sourceCode: _historyDemo4.default,
	              component: _react2.default.createElement(_historyDemo2.default, {
	                scPromise: this.scPromise,
	                configuration: this.state.configuration
	              }),
	              caption: _react2.default.createElement(
	                'span',
	                null,
	                ' Demo Application '
	              )
	            }),
	            _react2.default.createElement(_common.Cell, {
	              contentHeight: '400px',
	              showSourceCode: this.state.showSourceCode,
	              sourceCode: _history2.default,
	              component: _react2.default.createElement(_schviz2.default, {
	                scxmlDocumentString: _history2.default,
	                disableAnimation: true,
	                configuration: this.state && this.state.configuration,
	                disableZoomAnimation: true,
	                transitionsEnabled: this.state && this.state.transitionsEnabled,
	                expandAllStatesByDefault: true,
	                layoutOptions: _schviz2.default.layouts.auto,
	                id: 'history'
	              }),
	              caption: _react2.default.createElement(
	                'span',
	                null,
	                'State machine'
	              )
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(_components.ShowHideSourceCodeLink, { self: this })
	    );
	  };
	
	  return HistoryExample;
	}(_common.SCComponent);

/***/ }),

/***/ 440:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var React = _interopRequireWildcard(_react);
	
	var _TutorialPageWrapper = __webpack_require__(18);
	
	var _TutorialPageWrapper2 = _interopRequireDefault(_TutorialPageWrapper);
	
	var _historyExample = __webpack_require__(387);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var Introduction = function Introduction(_ref) {
	  var sectionName = _ref.sectionName,
	      by = _ref.by;
	  return React.createElement(
	    'div',
	    { className: 'container' },
	    React.createElement(
	      'h1',
	      null,
	      sectionName
	    ),
	    React.createElement(
	      'h6',
	      null,
	      by
	    ),
	    React.createElement(
	      'p',
	      null,
	      'The ',
	      React.createElement(
	        'code',
	        null,
	        'initial'
	      ),
	      ' attribute/node is great for specifying a default internal state inside a compound state, but it falls short of one major scenario: resuming where it left off.'
	    ),
	    React.createElement(
	      'p',
	      null,
	      'We have a lot of interaction scenarios where users essentially pause and resume the task at hand. Games, appliances, and UIs all often have this type of behavior, and it even manifests similarly.'
	    ),
	    React.createElement(
	      'p',
	      null,
	      'Imagine we have a simple photo gallery app with three views: gallery (all-up), carousel (one-up), and a sharing modal where users can share the album at any time.'
	    ),
	    React.createElement(
	      'h2',
	      null,
	      ' ',
	      React.createElement(
	        'code',
	        null,
	        '<history>'
	      ),
	      ', a link to the past '
	    ),
	    React.createElement(
	      'p',
	      null,
	      'Since the app should return to whichever view it was in before the user invoked the modal, initial states aren\u2019t enough. Instead, when the modal closes, we point to a history \u2018state\u2019, which is essentially a shortcut to the substate that was most recently active. That statechart looks like this:'
	    ),
	    React.createElement(_historyExample.HistoryExample, null),
	    React.createElement(
	      'p',
	      null,
	      'Since the interpreter always begins in the gallery, ',
	      React.createElement(
	        'code',
	        null,
	        '<history>'
	      ),
	      ' will point there unless the user visited the carousel most recently.'
	    )
	  );
	};
	
	var WrappedIntroduction = function WrappedIntroduction(_ref2) {
	  var location = _ref2.location;
	  return React.createElement(_TutorialPageWrapper2.default, { Component: Introduction, pathname: location.pathname });
	};
	
	exports.default = WrappedIntroduction;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-tutorials-history-js-2a4a9e653715cf125b6b.js